export const parseSearchParams = (paramName: string): string | null => {
	return new URL(window.location.href).searchParams.get(paramName);
};
